<template>
  <div class="view-forum">
    <community-shell
      :community-id="$route.params.id"
      active="forum"
      :search="search"
      @search="search = $event"
    >
      <action-dispatcher
        action="community/getForum"
        :parameters="$route.params.forumId"
      >
        <template #default="{ data: forum }">
          <div class="forum-header d-flex align-items-center">
            <button class="btn btn-back p-0 mr-3" @click="goBack">
              <i class="icon-chevron-left" />
            </button>
            <div class="flex-fill">
              <h5 class="forum-name mb-0">{{ forum.name }}</h5>
              <p class="forum-meta mb-0">
                <template v-if="forum.description">
                  {{ forum.description }}
                </template>
                <template v-if="topicsCount !== null">
                  <span v-if="forum.description" class="meta-separator"
                    >&bull;</span
                  >
                  {{ topicsCount }}
                  {{ topicsCount === 1 ? "tópico" : "tópicos" }}
                </template>
              </p>
            </div>
            <button
              v-if="!forum.is_archived"
              class="btn btn-new-topic"
              @click="composing = true"
            >
              <i class="icon-plus" /> Criar Tópico
            </button>
          </div>

          <p v-if="forum.is_archived" class="forum-archived mb-3">
            Este fórum foi arquivado. Não é possível publicar.
          </p>

          <community-feed
            ref="feed"
            :community-id="$route.params.id"
            :forum-id="$route.params.forumId"
            variant="topics"
            :search="search"
            @count-change="topicsCount = $event"
          />

          <topic-composer-modal
            v-model="composing"
            :forum-id="$route.params.forumId"
            @created="onTopicCreated"
          />
        </template>
      </action-dispatcher>
    </community-shell>
  </div>
</template>

<script>
import CommunityShell from "@/components/community/CommunityShell.vue";
import CommunityFeed from "@/components/community/CommunityFeed.vue";
import TopicComposerModal from "@/components/community/TopicComposerModal.vue";

export default {
  name: "ForumView",
  components: { CommunityShell, CommunityFeed, TopicComposerModal },
  data() {
    return {
      composing: false,
      topicsCount: null,
      search: ""
    };
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "community-forums",
        params: { id: this.$route.params.id }
      });
    },
    onTopicCreated() {
      if (this.$refs.feed) this.$refs.feed.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.view-forum {
  .forum-header {
    margin-bottom: 20px;

    .btn-back {
      border: none;
      background: transparent;
      color: inherit;

      i {
        font-size: 20px;
      }
    }

    .forum-name {
      font-size: 16px;
      font-weight: 600;
    }

    .forum-meta {
      font-size: 13px;
      opacity: 0.75;
      overflow-wrap: anywhere;

      .meta-separator {
        margin: 0 6px;
      }
    }

    .btn-new-topic {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      white-space: nowrap;
      padding: 6px 14px;
      height: 36px;
      min-height: 36px;
      font-size: 14px;
      border-radius: 8px;
      border: 1px solid transparent;
      background: #0f2938;
      color: #fcfcfc;

      &:hover {
        border-color: #438a98;
        color: #fcfcfc;
      }

      i {
        font-size: 13px;
      }
    }
  }

  .forum-archived {
    padding: 16px;
    border-radius: 12px;
    border: 1px solid rgba(255, 179, 71, 0.4);
    background: rgba(255, 179, 71, 0.12);
    font-size: 14px;
  }
}
</style>
